import React from "react";
import { Stack, Chip } from "@mui/material";

const ProductTags = ({ allergens, dietaryTags, ingredients, theme }) => {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      flexWrap="wrap"
      justifyContent="center">
      {dietaryTags.length > 0 &&
        dietaryTags.map((tag) => (
          <Chip
            key={tag._id}
            label={tag.label}
            size="small"
            sx={{
              backgroundColor: theme.palette.success.light,
              color: "#fff",
              fontWeight: 500,
            }}
          />
        ))}
      {allergens.length > 0 &&
        allergens.map((allergen) => (
          <Chip
            key={allergen._id}
            label={allergen.name}
            size="small"
            sx={{
              backgroundColor: theme.palette.warning.light,
              color: "#fff",
              fontWeight: 500,
            }}
          />
        ))}
      {ingredients.length > 0 &&
        ingredients.map((ing) => (
          <Chip
            key={ing._id}
            label={ing.name}
            size="small"
            variant="outlined"
            sx={{
              borderColor: "#ccc",
              color: "#555",
              fontWeight: 500,
            }}
          />
        ))}
    </Stack>
  );
};

export default ProductTags;
